import React, { useEffect, useState } from "react";
import api from "../../lib/api";

export default function AdminAnalytics() {
    const [data, setData] = useState(null);
    useEffect(() => { document.title = "Admin Analytics | Loomara"; api.get("/analytics/summary").then(({ data }) => setData(data)); }, []);
    if (!data) return <p>Loading…</p>;
    return (
        <div data-testid="admin-analytics-page">
            <p className="eyebrow">Insights</p>
            <h1 className="font-serif text-4xl text-ink-900 mt-2 mb-8">Analytics</h1>

            <div className="card-soft p-8">
                <h3 className="font-serif text-2xl mb-4">Events Breakdown</h3>
                {Object.keys(data.byEvent).length === 0 ? (
                    <p className="text-ink-500 text-sm">No events tracked yet. As shoppers browse, you'll see events here.</p>
                ) : (
                    <ul className="divide-y divide-sage-300/20">
                        {Object.entries(data.byEvent).map(([k, v]) => (
                            <li key={k} className="flex justify-between py-2.5 text-sm">
                                <span className="text-ink-900">{k}</span>
                                <span className="text-sage-700 font-medium">{v}</span>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
}
